import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiEventManager,JhiParseLinks} from 'ng-jhipster';
import {BsModalRef,ModalDirective} from 'ngx-bootstrap';
import {Subscription} from 'rxjs';
import {Principal} from 'src/app/core';
import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';
import {IUnderwriterMySuffix} from 'src/app/shared/model/underwriter-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {UnderwriterMySuffixService} from './underwriter-my-suffix.service';


declare var $:any;

@Component({
    selector: 'jhi-underwriter-my-suffix',
    templateUrl: './underwriter-my-suffix.component.html'
})
export class UnderwriterMySuffixComponent implements OnInit, OnDestroy {
    currentAccount: any;
    underwriters: IUnderwriterMySuffix[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    searchText: string;
    flag: boolean;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    underwriterId: number;
    modalTitle: string = 'Confirm operation';
    modalContent: string;
    status: string = '';
    showActiveModel: boolean = false;
   underwritwerName: any;
    accessClientId: number
    accessPlatform: boolean = false;
    isLoginEmail: any;

    @ViewChild('underwriterAccessModal') underwriterAccessModal: ModalDirective;

    public readonly RoleUtil = RoleUtil;

    constructor(
        private underwriterService: UnderwriterMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        public principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: JhiEventManager,
        private languageChangeService: LanguageChangeService,
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
            // if (this.itemsPerPage == 25 && this.page > 1) {
            //     this.page = 1;
            //     this.previousPage = 1;
            // }
        });
                this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
    }

    loadAll() {
        this.searchText = "";
        this.underwriterService
            .query({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<IUnderwriterMySuffix[]>) => this.paginateUnderwriters(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.searchText) {
            this.searchItems();
            this.flag = true;
        } else {
            this.router.navigate(['/data-management/underwriter'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
            this.loadAll();
        }
    }

    clear() {
        this.page = 0;
        this.router.navigate([
            '/data-management/underwriter',
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        ]);
        this.loadAll();
    }
    addZeroPadding: boolean;
    ngOnInit() {
        this.principal.setTitle("Underwriters");
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.loadAll();
        this.principal.identity().then(account => {
            this.currentAccount = account;
            // 'INSURER','INSURER_STAFF','UNDERWRITER','UNDERWRITER_STAFF
            if (this.currentAccount) {
                if ((this.currentAccount.userRole != "BROKER") && (this.currentAccount.userRole != "BROKER_STAFF")
                    && (this.currentAccount.userRole != "INSURER") && (this.currentAccount.userRole != "INSURER_STAFF") &&
                    (this.currentAccount.userRole != "UNDERWRITER") && (this.currentAccount.userRole != "UNDERWRITER_STAFF")) {
                    this.addZeroPadding = true;
                } else {
                    this.addZeroPadding = false;
                }
            }

        });

        this.registerChangeInUnderwriters();
    }

    ngOnDestroy() {
        if (this.eventSubscriber)
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: IUnderwriterMySuffix) {
        return item.id;
    }

    registerChangeInUnderwriters() {
        this.eventSubscriber = this.eventManager.subscribe('underwriterListModification', response => this.loadAll());
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private paginateUnderwriters(data: IUnderwriterMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.underwriters = data;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    get authority() {
        return this.principal.userIdentity.authorities[0];
    }
    searchItems() {
        if (this.searchText) {
            var pNo = 0;
             var size = this.itemsPerPage;
            if (this.flag == true) {
                pNo = this.page - 1;
                size = this.itemsPerPage;
                this.flag = false;
            }
            this.principal
                .searchQuery(this.searchText, 'underwriters/search', {
                    page: pNo,
                    size: size,
                    sort: this.sort()
                })
                .subscribe(
                    (res: HttpResponse<IUnderwriterMySuffix[]>) => this.paginateUnderwriters(res.body, res.headers),
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        } else {
            this.loadAll();
        }
    }

    // global modal open and close event
    bsModalRef: BsModalRef;

    openInformationModel(mainObject) {
        // if (mainObject.id !== null && mainObject.id !== undefined) {
        //     let form_data = {
        //         masterId: mainObject.id,
        //         informationType: InformationType.UNDERWRITER.valueOf()
        //     }
        //     this.informationModelService.fetchExistedInformationDetailsByType(form_data).subscribe(response => {
        //         const resBody = response.body;
        //         if (resBody && resBody.length > 0) {
        //             const initialState = {
        //                 isUpdateType: false,
        //                 mainList: resBody,
        //             };
        //             this.bsModalRef = this.modalService.show(InformationModelComponent, { initialState, class: "modal-lg" });
        //             this.bsModalRef.content.onClose.subscribe(result => {
        //                 console.log(result);
        //             });
        //         } else {
        //             this.router.navigate(['/data-management', { outlets: { popup: 'underwriter/' + mainObject.id + '/delete' } }]);
        //         }
        //     });
        // }

        this.underwriterService.checkForUnderwriterInPolicy(mainObject.id).subscribe(res => {
            if(res&&res.body&&res.body.payload&&res.body.payload.length>0) {
                this.jhiAlertService.error('Underwriter is present in polices '+res.body.payload);
            } else {
                this.openActivateModal('InActivate', mainObject.id)
            }
        });

    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewFutureHistory(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Underwriter (' + Obj.name + ') Future Records';
        this.historyType = "UNDERWRITERS_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Underwriter (' + Obj.name + ') History';
        this.historyType = "UNDERWRITERS_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }
    onChange(value) {
        this.page = 0;
        this.itemsPerPage = value
        this.loadAll();
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }
    openActivateModal(status, underwriterId) {
        this.showActiveModel = true;
        this.underwriterId = underwriterId;
        if (status == 'ACTIVATE') {
            this.modalContent = 'Are you sure you want to activate this Underwriter?'
            this.status = 'ACTIVE';
        } else {
            this.modalContent = 'Are you sure you want to In-activate this Underwriter?'
            this.status = 'IN_ACTIVE'
        }
    }

    changeUnderwriterStatus() {
        if (this.underwriterId) {
            this.underwriterService.delete(this.underwriterId).subscribe(response => {
                if (this.status == 'ACTIVE') {
                    this.jhiAlertService.success('The underwriter has been activated successfully')
                } else {
                    this.jhiAlertService.success('The underwriter has been de-activated successfully')
                }
                this.loadAll();
            });
        }
    }

    closeActiveModels(e: boolean) {
        this.showActiveModel = e;
    }

    hideUnderwriterAccessModal() {
        this.underwriterAccessModal.hide()
    }

    openAccessModalPopup(status, und) {
        this.underwritwerName = und.name;
        this.accessClientId = und.id;
        this.isLoginEmail = und.loginEmailAddress ? und.loginEmailAddress : "";
        this.underwriterAccessModal.show();
        if (status == "Access") {
            this.accessPlatform = true;
        } else {
            this.accessPlatform = false;
        }
    }
    getAccessPermission() {
        if (this.accessClientId)
            this.underwriterService.accessPlatform(this.accessClientId).subscribe((p: any) => {
                if (p) {
                    this.loadAll();
                    this.jhiAlertService.success(p.body.message);
                }
            })
        this.hideUnderwriterAccessModal();
    }
}
